import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  ClientDataTableItem,
  ClientsService,
} from 'src/app/services/clients/clients.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeButtonComponent } from '../../../../shared/payee-buttons/payee-button/payee-button.component';

@Component({
  selector: 'app-delete-client-dialog',
  templateUrl: './delete-client-dialog.component.html',
  styleUrls: ['./delete-client-dialog.component.scss'],
  imports: [PayeePopupComponent, PayeeButtonComponent, MatDialogClose],
})
export class DeleteClientDialogComponent {
  private clientsService = inject(ClientsService);
  private snackbar = inject(MatSnackBar);

  dialogRef = inject<MatDialogRef<DeleteClientDialogComponent>>(MatDialogRef);
  client = inject<ClientDataTableItem>(MAT_DIALOG_DATA);

  submitLoading = false;

  async submit() {
    if (this.submitLoading) {
      return;
    }

    try {
      this.submitLoading = true;

      await this.clientsService.deleteClient(this.client.id);

      this.dialogRef.close(true);
    } catch (error) {
      console.error('Error while deleting client', error);
      this.snackbar.open('Valami hiba történt!', 'OK', {
        duration: 5000,
      });
      this.dialogRef.close();
    } finally {
      this.submitLoading = false;
    }
  }
}
